<template>
  <div style="overflow: auto; margin-top: 20px;">
    <div style="display: inline-flex;">
      <div>
        <div>ทั้งหมด</div>
        <div
          class="message mr-2"
          style="
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 22px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        "
        >
          <uploadfile
            ref="answer"
            v-model="value[0]['0']"
            :height="181"
            data-vv-as="Image"
            :data-vv-name="'answer_' + '_image_'"
            v-validate
          ></uploadfile>
        </div>
      </div>
      <div>
        <div>ลดราคา</div>
        <div
          class="message mr-2"
          style="
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 22px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        "
        >
          <uploadfile
            ref="answer"
            v-model="value[1]['1']"
            :height="181"
            data-vv-as="Image"
            :data-vv-name="'answer_' + '_image_'"
            v-validate
          ></uploadfile>
        </div>
      </div>
      <template v-if="categories.length >= 1">
        <template v-for="(item, i) in categories">
          <div :key="i">
            <div>{{ item.name }}</div>
            <div
              class="message mr-2"
              style="
        position: relative;
        border-radius: 12px;
        width: 181px;
        overflow-wrap: break-word;
        min-height: 22px;
        min-width: 14px;
        line-height: 15.36px;
        overflow: hidden;
        "
            >
              <uploadfile
                ref="answer"
                v-model="value[i][item.id]"
                :height="181"
                data-vv-as="Image"
                :data-vv-name="'answer_' + '_image_'"
                v-validate
              ></uploadfile>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value', 'categories'],
  components: {
    uploadfile
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/ImageCategories.vue